import { ReactNode } from "react";
import { Link } from "@carbon/react";
import i18next from "../../i18n";
import { OrderResponse } from "../../types";
import { serviceToQuoteOf } from "../../containers/Order/serviceDetail";
import "./serviceAsked.scss";

/**
 * SCRUM-116: what the buyer asked of a service quoted by line — its name, objective and scope,
 * deliverables and additional document — shown beside its line prices, where the supplier quotes
 * and reads its offer, instead of in the "Servicios a cotizar" card. Rows without a value are left
 * out. Renders `dt`/`dd` pairs: the caller supplies the `dl`.
 */
const ServiceAsked = ({ order }: { order: OrderResponse }) => {
  const service = serviceToQuoteOf(order);
  const rows: [string, ReactNode][] = [
    [i18next.t("serviceDetail.serviceName"), service?.title],
    [i18next.t("serviceDetail.objectiveAndScope"), service?.objective],
    [i18next.t("serviceDetail.scope"), service?.scope],
    [i18next.t("serviceDetail.deliverables"), service?.deliverables],
    [
      i18next.t("serviceDetail.additionalDocument"),
      (service?.files ?? []).length > 0 && (
        <span className="service-asked__links">
          {service!.files.map((file) => (
            <Link
              key={file.fileURL}
              href={file.fileURL}
              target="_blank"
              rel="noopener noreferrer"
              size="sm"
            >
              {file.name}
            </Link>
          ))}
        </span>
      ),
    ],
  ];
  return (
    <>
      {rows
        .filter(([, value]) => !!value)
        .map(([label, value]) => (
          <div key={label} className="service-asked">
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
    </>
  );
};

export default ServiceAsked;
